// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		let menuItem = $('.privary-navigation__item');
		

		$('.js-open-menu').click(function(event){
			$('#menu-content').addClass('show');
			$('#overlay-menu').addClass('show');
		});
	
		$('#close-menu').click(function(event){
			$('#menu-content').removeClass('show');
			$('#overlay-menu').removeClass('show');
			$('.privary-navigation__item').removeClass('show');
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		if($('.map-attractions').length > 0){
			$('.map-attractions__info ul li').mouseover(function(){
				$('.'+ $(this).data('hover')).addClass('hover-state');
			});

			$('.map-attractions__info ul li').mouseout(function(){
				$('.'+ $(this).data('hover')).removeClass('hover-state');
			});
		}

		if($('.map-attractions-v2').length > 0){
			$('.map-attractions-v2__info ul li').mouseover(function(){
				$('.'+ $(this).data('hover')).addClass('hover-state');
			});

			$('.map-attractions-v2__info ul li').mouseout(function(){
				$('.'+ $(this).data('hover')).removeClass('hover-state');
			});
		}


		$('.home_slider').slick({
			accessibility: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 6000,
			pauseOnHover: false,
			speed: 700,
			fade: true,
			prevArrow: '.arrow-home__prev',
			nextArrow: '.arrow-home__next'
		});

		if($('#list-index-pp').length > 0){
			$('#list-index-pp li a').click(function(){
				var tag = $(this).attr("href");
				$('html,body').animate({
					scrollTop: $(tag).offset().top - 200
				}, 1500);
				return false;
			})
		}

		$('.accomodation-slides').slick({
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			fade: true,
			accessibility: true
		});

		$('.js-getRooms').click(function(){
			$('.accomodation-slides').slick('unslick');
			const thisTag = $(this).attr('data-tag');
			if(thisTag == 'all'){
				$('.grid--filter .grid__col').hide();
				$('.grid--filter .all_rooms').hide();
				$('.grid--filter .all_rooms').fadeIn();
				$('.grid--filter .all_rooms .accomodation-slides').slick({
					arrows: true,
					dots: false,
					autoplay: false,
					autoplaySpeed: 5000,
					speed: 500,
					fade: true,
					accessibility: true
				});
				$('.js-getRooms').removeClass('active');
				$('.js-getRooms').attr("aria-selected", "false");

				$(this).addClass('active');
				$(this).attr("aria-selected", "true");
				$.each($('.grid--filter .all_rooms'), function(index,value){
					if(index % 2 != 0){
						$(this).addClass('reverse');
					}
				});
			}else{
				$('.grid--filter .all_rooms').removeClass('reverse');
				$('.grid--filter .all_rooms').hide();
				$('.grid--filter .grid__col').removeClass('reverse');
				$('.grid--filter .grid__col').hide();
				$('.grid--filter .'+thisTag).fadeIn();
				$('.grid--filter .'+thisTag+' .accomodation-slides').slick({
					arrows: true,
					dots: false,
					autoplay: false,
					autoplaySpeed: 5000,
					speed: 500,
					fade: true,
					accessibility: true
				});
				$('.js-getRooms').removeClass('active');
				$('.js-getRooms').attr("aria-selected", "false");
				$(this).addClass('active');
				$(this).attr("aria-selected", "true");
				$.each($('.grid--filter .'+thisTag), function(index,value){
					if(index % 2 != 0){
						$(this).addClass('reverse');
					}
				});
			}
		})
	
		if(document.querySelector('.accommodations-shortcode')){
			const filter_tab = document.querySelectorAll('.js-getRooms'); filter_tab[0].click();
		}

		$('.attractions-shortcode__slider').slick({
			adaptiveHeight: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 5000,
			speed: 700,
			fade: false,
			accessibility: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			draggable: false,
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				  }
				}
			]
		});

		$('.attractions-shortcode__filter .list button').click(function(){
			$('.attractions-shortcode__slider').slick('unslick');
			const tag = $(this).attr('data-tag');
			$('.attractions-shortcode__container').hide();
			$('.attractions-shortcode__container.'+tag).fadeIn();
			$('.attractions-shortcode__filter .list button').removeClass('active');
			$(this).addClass('active');
			$('.attractions-shortcode__container .attractions-shortcode__slider').slick({
				arrows: true,
				adaptiveHeight: true,
				autoplay: false,
				autoplaySpeed: 5000,
				speed: 700,
				accessibility: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				draggable: true,
				responsive: [
					{
					  breakpoint: 1024,
					  settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					  }
					}
				]
			});
		})
	
		if(document.querySelector('.attractions-shortcode')){
			const filter_tab = document.querySelectorAll('.attractions-shortcode__filter .list button'); filter_tab[filter_tab.length - 1].click();
		}

		$('.dine-quad__slider').slick({
			accessibility: true,
			arrows: true,
			dots: false,
			autoplay: false,
			autoplaySpeed: 7000,
			speed: 700,
			fade: true
		});
		

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		//scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};


	var $slider = $('.view-all');
	$slider.on('init', function(event, slick){
		adjustSliderHeight();
	});
	$slider.on('afterChange', function(event, slick, currentSlide){
		adjustSliderHeight();
	});

	$slider.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		adaptiveHeight: true,
		arrows: true,
	});

	function adjustSliderHeight() {
		var $activeSlides = $slider.find('.slick-slide.slick-active');
		var maxHeight = 0;
		$activeSlides.each(function() {
			var slideHeight = $(this).outerHeight();
			if (slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});
		$slider.find('.slick-list').height(maxHeight);
	}
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 20){
		// if(document.getElementById('home')){
		// 	if(st > lastScrollTop){
		// 		$('.content-menu').removeClass('home');
		// 	}else{
		// 		$('.content-menu').addClass('home');
		// 	}
		// }
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}